(function(angular) {
    angular.module('wtApp.wtTracking.errorHandler').config(errorHandlerConfig);

    errorHandlerConfig.$inject = ['$httpProvider'];
    function errorHandlerConfig($httpProvider) {
        $httpProvider.interceptors.push('wtErrorPigeonInterceptor');
    }
})(window.angular);
